import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Decorative } from "@faire/design-tokens";
import { HeroSection } from "@faire/retailer-visitor-shared/views/careers/__internal__/components/HeroSection";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React from "react";
import styled from "styled-components";
export var JobOpeningsHeroSection = function() {
    var strictLocalize = useStrictLocalization().strictLocalize;
    var headerText = strictLocalize({
        id: "5W3FYQ",
        defaultMessage: [
            {
                type: 0,
                value: "Interested in joining our team?"
            }
        ]
    });
    var eyebrowText = strictLocalize({
        id: "Rz65jE",
        defaultMessage: [
            {
                type: 0,
                value: "Careers at faire"
            }
        ]
    });
    var IMAGES = [
        "https://cdn.faire.com/fastly/5819985503dbb4c21748a7eb67951c137c8f90d274107b8c8c7abb6fdf8ea01f.png"
    ];
    return /*#__PURE__*/ _jsxs(HeroSection, {
        eyebrowText: eyebrowText,
        heroImages: IMAGES,
        backgroundColor: Decorative.tint.neutral,
        children: [
            /*#__PURE__*/ _jsx(MobileHeaderTextWidth, {
                variant: {
                    mobileAndAbove: "displayMSerifRegular",
                    desktopAndAbove: "displayLSerifRegular"
                },
                children: headerText
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: {
                    mobileAndAbove: "2x",
                    desktopAndAbove: "3x"
                }
            }),
            /*#__PURE__*/ _jsx(MobileTextWidth, {
                variant: {
                    mobileAndAbove: "paragraphSansRegular",
                    desktopAndAbove: "subheadingSansMedium"
                },
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "f6TP4U",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Help create a bright future for independent retailers and brands around the world."
                        }
                    ]
                })
            })
        ]
    });
};
var MobileHeaderTextWidth = styled(Typography).withConfig({
    componentId: "sc-a005b8c2-0"
})([
    "",
    "{max-width:",
    ";}"
], responsiveMediaQueries.mobile, getSpacing(300));
var MobileTextWidth = styled(Typography).withConfig({
    componentId: "sc-a005b8c2-1"
})([
    "",
    "{max-width:",
    ";}"
], responsiveMediaQueries.mobile, getSpacing(230));
